// =  require moment/moment

import 'angular';
import { editReportPathFromTypeAndId } from '../../../admin/admin_funding/helpers/utilities';
import routesModule from '../../../utilities/routes_module';
import '../../../../../lib/assets/javascripts/devex/urls';
import '../../../../assets/javascripts/ui_toolbox/devex.user.js';
import template from './report_details.template.html?raw';
// Services
import '../services/url_handling.service';
// Nested directives/components
import '../components/report_summary.component';
import './action_bar.directive';
import './report_header.directive';
import './report_shortlisted.directive';
import './report_timeline.directive';
import './report_contacts.directive';
import './report_description.directive';

const moduleDependencies = [
  // Components
  'fundingSearchApp.components.reportSummary',
  // Directives
  'fundingSearchApp.directives.actionBar',
  'fundingSearchApp.directives.reportHeader',
  'fundingSearchApp.directives.reportShortlisted',
  'fundingSearchApp.directives.reportTimeline',
  'fundingSearchApp.directives.reportContacts',
  'fundingSearchApp.directives.reportDescription',
];

const reportDetailsController = function () {
  const that = this;

  that.$onInit = () => {
    that.isSignedIn = devex.data.userSignedIn;
  };

  /**
   *
   * @param {String} publishedAt - Date string of when the report was published
   * @returns {boolean} true if the report was published within the last 7 days
   */
  that.isNewReport = (publishedAt) => {
    if (!publishedAt) return false;
    const publishedDate = new Date(publishedAt);
    const oneWeekAgo = new Date();

    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    return publishedDate >= oneWeekAgo;
  };

  /**
   * Determines if one of the donors at least has a logo
   *
   * @returns {boolean} If true, set specific CSS class to display logo
   */
  that.hasDonorLogo = () => {
    if (that.report) {
      if (that.report.donors) {
        return that.report.donors.some((donor) => donor.logo);
      }
    }
    return false;
  };

  that.firstDonorLogoUrl = () => {
    let logoUrl = '';
    angular.forEach(that.report.donors, (donor) => {
      if (logoUrl === '') {
        if (donor.logo) {
          logoUrl = donor.logo;
        }
      }
    });
    return logoUrl;
  };

  /**
   * Determines related report URL
   * @param {Object} report - Report object
   * @returns {null | string} Returns URL to related report, or null if no report provided
   */
  that.relatedReportPath = (report) => {
    if (!report) return null;
    return routesModule.funding_search_path(
      { report: report.report_type.toLowerCase() + '-' + report.id }
    );
  };

  /**
   * Determines DevData Admin Panel edit report URL
   *
   * @returns {null | string} Returns URL, in order for our team, to directly navigate to
   *                        NewsLab in order to edit report
   */
  that.editReportPath = () => {
    if (that.report) {
      return editReportPathFromTypeAndId(that.report.type, that.report.id);
    }
    return null;
  };

  that.currentPath = () => routesModule.funding_search_path(devex.urls.getParams());

  /**
   * Checks if the property exists with a valid value (not empty string,
   * not 0 number, not empty array, not empty object, not null, not undefined)
   * on the report
   *
   * @param {string} prop - Property to be checked
   * @returns {boolean} true if the property exists on the report with a valid
   *                    value, false if not
   */
  that.reportContainsValid = (prop) => that.report && devex.util.containsProp(that.report, prop);

  that.reportOfType = (types) => {
    let result = false;

    if (that.report && that.report.type) {
      result = devex.util.propertyIncludes(that.report.type, types);
    }

    return result;
  };

  that.displayShortlistedSection = () => {
    const consortiums = that.reportContainsValid('consortiums');
    const organizations = that.reportContainsValid('organizations');
    return that.reportOfType('shortlist') && (consortiums || organizations);
  };
};

const controller = ['$window', reportDetailsController];

angular
  .module('fundingSearchApp.directives.reportDetails', moduleDependencies)
  .run([
    '$templateCache',
    ($templateCache) => {
      $templateCache.put(template, template);
    },
  ])
  .directive('reportDetails', [
    () => ({
      restrict: 'E',
      bindToController: true,
      controllerAs: 'vm',
      controller,
      templateUrl: template,
      scope: {
        paywallUrl: '=',
        csrfToken: '=',
        report: '=',
        isExpandedView: '=',
        toggleTrackReport: '=',
        userPermissions: '=',
      },
    }),
  ]);
